<template>
  <div>
    <nav-bar></nav-bar>
    <div class="container">
      <div class="section">

        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li><a @click="$router.push('/clients')">{{ CONSTANTS.getCopy('SENTENCEANSWERS_BREADCRUMB_CHATBOTS') }}</a></li>
            <li><a @click="$router.push('/clients/' + client + '/intents')">{{ clientName }}</a></li>
            <li><a @click="$router.push('/clients/' + client + '/intents/' + intent + '/sentences')">{{ intentName }}</a></li>
            <li><a @click="$router.push('/clients/' + client + '/intents/' + intent + '/sentences')">{{ sentenceName }}</a></li>
            <li class="is-active"><a href="#" aria-current="page">{{ CONSTANTS.getCopy('SENTENCEANSWERS_BREADCRUMB_ANSWERS') }}</a></li>
          </ul>
        </nav>

        <div class="button is-primary is-left" @click="storeAnswer">
          <span class="icon"><i class="fas fa-plus"></i></span>
          <span class="is-capitalized">{{ CONSTANTS.getCopy('SENTENCEANSWERS_NEW_ANSWER') }}</span>
        </div>
        <div @click="storeChatGptPrompt" class="button is-black is-left">
          <span class="icon"><i class="fas fa-plus"></i></span>
          <span>{{ CONSTANTS.getCopy('SENTENCEANSWERS_GPT_PROMPT') }}</span>
        </div>
        <br><br>
        <table class="table is-striped is-fullwidth">

          <thead>
            <tr>
              <th class="is-capitalized">{{ CONSTANTS.getCopy('SENTENCEANSWERS_TABLE_HEADER_ANSWER') }}</th>
              <th class="is-capitalized has-text-centered">{{ CONSTANTS.getCopy('SENTENCEANSWERS_TABLE_HEADER_GPT_PROMPT') }}</th>
              <th class="is-capitalized has-text-centered">{{ CONSTANTS.getCopy('SENTENCEANSWERS_TABLE_HEADER_PROCESS_CONN') }}</th>
              <th class="table-button-column"></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="answer in answers" :key="answer.id">
              <td>{{ answer.chatGPT === 1 ? answer.promptTitle : answer.response }}</td>
              <td class="has-text-centered">
                <span v-if="answer.chatGPT" class="icon has-text-success">
                  <i class="fas fa-check"></i>
                </span>
              </td>
              <td class="has-text-centered">
                <span v-if="answer.process" class="icon has-text-success">
                  <i class="fas fa-check"></i>
                </span>
              </td>
              <td>
                <div class="field has-addons">
                  <p class="control">
                    <a @click="updateAnswer(answer)" class="button is-warning" title="Editar">
                      <span class="icon"><i class="fas fa-edit"></i></span>
                    </a>
                  </p>
                  <p class="control">
                    <a @click="deleteAnswer(answer)" class="button is-danger" title="Eliminar">
                      <span class="icon"><i class="fas fa-trash-alt"></i></span>
                    </a>
                  </p>
                </div>
              </td>
            </tr>
          </tbody>

        </table>
      </div>
    </div>
  </div>
</template>

<script>
import CONSTANTS from '../../../../constants'
export default {
  data () {
    return {
      client: this.$route.params.client,
      clientName: 'Chatbot',
      intent: this.$route.params.intent,
      intentName: 'Intención',
      sentence: this.$route.params.sentence,
      sentenceName: 'Frase',
      answers: {},
      documentIntentsStartsWith: ['Images', 'Audios', 'Videos', 'Gif', 'Files']
    }
  },
  created () {
    this.getAnswers()
    this.breadcrumbDetails()
  },
  methods: {
    breadcrumbDetails () {
      this.api.post('/ClientById/', { idClient: this.client }).then(response => {
        this.clientName = response.client.name
      })
      this.api.post('/IntentById', { idIntent: this.$route.params.intent }).then(response => {
        this.intentName = response.intent.name
      })
      this.api.post('/PhraseById', { idDictionary: this.sentence }).then(response => {
        this.sentenceName = response.phrase.term
      })
    },
    go (uri) {
      let baseUrl = '/clients/' + this.client + '/intents/' + this.intent + '/sentences/' + this.sentence + '/answers/'
      this.$router.push(baseUrl + uri)
    },
    getAnswers () {
      this.api.post('/ResponseGetList', { idDictionary: this.sentence }).then(response => {
        this.answers = response.responses
      })
    },
    storeAnswer () {
      this.go('store')
    },
    storeChatGptPrompt () {
      this.go('chatgpt/store')
    },
    updateAnswer (answer) {
      if (answer.chatGPT === 1) {
        this.go(answer.idResponse + '/chatgpt/update')
        return
      }

      if (this.checkDocumentIntent(answer.response)) {
        this.dialog.updateAnswerFile(answer).then(() => {
          this.getAnswers()
        })
        return
      }

      this.go(answer.idResponse + '/update')
    },
    deleteAnswer (answer) {
      let message = CONSTANTS.getCopy('SENTENCEANSWERS_CONFIRM_DELETE_ANSWER')

      this.dialog.confirm({ message }).then(() => {
        this.api.post('/ResponseDelete', answer).then(() => {
          this.getAnswers()
        })
      }).catch(() => { })
    },
    checkDocumentIntent (response) {
      const splitedResponse = response.split('/')
      if (this.documentIntentsStartsWith.includes(splitedResponse[0])) {
        return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Intents/sentencesAndAnswers/commonAndDefaultAnswers/SentenceAnswers.vue